module.exports = __webpack_public_path__ + "components/layout/images/footer_subscription.jpg?c0b95959";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/footer_subscription.jpg
// module id = 240
// module chunks = 0